import React, { useMemo, useState } from 'react';
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import * as Icons from 'react-feather';
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg';
import { logAuditEvent } from '../../utils/auditLogger';

function TodoListGrid({ TodoListData = [], UserPermissions = {}, onAction, moduleName = 'Todo List' }) {
  const [filterText, setFilterText] = useState('');

  const rows = useMemo(() => {
    const term = filterText.toLowerCase();
    return (TodoListData || []).filter((item) => {
      const title = item.Title ? item.Title.toLowerCase() : '';
      const description = item.Description ? item.Description.toLowerCase() : '';
      return title.includes(term) || description.includes(term);
    });
  }, [TodoListData, filterText]);

  const openActionType = (row, action) => {
    logAuditEvent(moduleName, 'View/Edit/Delete Button Click', JSON.stringify({ Id: row?.TodoId, Name: row?.Title, Action: action }));
    onAction(row, action);
  };

  const columns = [
    {
      name: <div className="titlename"><span>Title</span></div>,
      selector: (row) => row.Title,
      sortable: true,
      sortIcon: <SortArrow />,
      grow: 1.3
    },
    {
      name: <div className="titlename"><span>Description</span></div>,
      selector: (row) => row.Description,
      sortable: true,
      sortIcon: <SortArrow />,
      grow: 2,
      cell: (row) => <span title={row.Description || ''}>{row.Description || '-'}</span>
    },
    {
      name: <div className="titlename"><span>Due Date</span></div>,
      selector: (row) => row.DueDate,
      sortable: true,
      sortIcon: <SortArrow />,
      cell: (row) => row.DueDate ? moment(row.DueDate).format('DD MMM YYYY, hh:mm A') : '-'
    },
    {
      name: <div className="titlename"><span>Scheduled</span></div>,
      selector: (row) => Number(row.IsScheduled),
      sortable: true,
      sortIcon: <SortArrow />,
      cell: (row) => Number(row.IsScheduled) === 1 ? 'Yes' : 'No',
      width: '120px'
    }
  ];

  if (UserPermissions.ViewModule === 1 || UserPermissions.EditModule === 1 || UserPermissions.DeleteModule === 1) {
    columns.push({
      name: <div className="titlename">Actions</div>,
      width: '150px',
      center: true,
      cell: (row) => (
        <div className="edit-delete-action">
          {UserPermissions.ViewModule === 1 ? (
            <Link className="me-2 p-2" to="" onClick={() => openActionType(row, 'View')}>
              <Icons.Eye className="action-eye" />
            </Link>
          ) : null}
          {UserPermissions.EditModule === 1 ? (
            <Link className="me-2 p-2" to="" onClick={() => openActionType(row, 'Edit')}>
              <Icons.Edit className="feather-edit" />
            </Link>
          ) : null}
          {UserPermissions.DeleteModule === 1 ? (
            <Link className="confirm-text p-2" to="" onClick={() => openActionType(row, 'Delete')}>
              <Icons.Trash2 className="feather-trash-2" />
            </Link>
          ) : null}
        </div>
      )
    });
  }

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <div className="search-set">
            <div className="search-input">
              <button type="button" className="btn btn-searchset">
                <Icons.Search className="feather-search" />
              </button>
              <input
                id="search"
                type="text"
                className="form-control form-control-sm custom-search-input"
                placeholder="Search"
                aria-label="Search Input"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
          </div>
        </div>
        <DataTable
          className="table-responsive product-list"
          columns={columns}
          data={rows}
          pagination
          sortIcon={<SortArrow />}
          persistTableHead={true}
          defaultSortField="Title"
        />
      </div>
    </div>
  );
}

export default TodoListGrid;
